module.exports = __webpack_public_path__ + "static/media/18_TOP_FRENTE_UNICA_COM_BOJO_ESTAMPADO_03.8649da98.jpg";